import styled from 'styled-components';
import { breakpoints } from 'modules/breakpoints';
import { pxToRem } from 'modules/spacing';
import { themeGet } from 'modules/tetrisTheme';
import { TableBodyCell } from '../TableCell';
import { TableRow } from '../TableRow/TableRow';
export const TableCollapseBodyCell = styled.td `
  padding: ${themeGet('spacing.sm')} ${themeGet('spacing.md')};

  ${breakpoints.sm} {
    ${(props) => `padding: ${themeGet('spacing.xl')} calc(${themeGet('spacing.2xl')} + ${pxToRem(props.$offset)});`}
  }
`;
export const StyledTableBodyCell = styled(TableBodyCell) `
  ${(props) => props.$hideOnBreakpoint && breakpoints[props.$hideOnBreakpoint]} {
    display: none;
  }
`;
export const TableCollapseRow = styled(TableRow) `
  ${(props) => props.$hideOnBreakpoint && breakpoints[props.$hideOnBreakpoint]} {
    display: none;
  }
`;
